import { createAuth0 } from '@auth0/auth0-vue';

// Capture Auth0 callback error query params once at module load, before the
// Auth0 plugin installs and strips them via history.replaceState. Require both
// error and state so unrelated ?error= params on normal routes are ignored.
const captureAuthCallbackError = () => {
    const params = new URLSearchParams(window.location.search);

    if (params.get('error') && params.get('state')) {
        return {
            error: params.get('error'),
            error_description: params.get('error_description') || '',
        };
    }

    return null;
};

export const authCallbackError = captureAuthCallbackError();

export const auth0 = createAuth0({
    domain: window.__KEAP__.VUE_APP_AUTH0_DOMAIN,
    clientId: window.__KEAP__.VUE_APP_AUTH0_CLIENT_ID,
    authorizationParams: {
        redirect_uri: window.location.origin,
        audience: window.__KEAP__.VUE_APP_AUTH0_AUDIENCE,
    },
    cacheLocation: 'localstorage',
}, {
    errorPath: '/auth-error',
});

// Current user's email, or '' before Auth0 has resolved the session.
export const getUserEmail = () => auth0.user.value?.email || '';

// Single entry point for the Auth0 login redirect so every caller stores the
// same appState shape. `target` is the in-app path to return to after callback.
export const redirectToLogin = (target) => auth0.loginWithRedirect({ appState: { target } });
